import React from 'react'
import { inject, observer } from 'mobx-react'
import Icon from 'components/common/Icon'
import { withTranslation, Trans } from 'react-i18next'
import constants from '../../constants'

const RegionAnalysisInvalid = ({ selectionStore, t }) => (
  <section className='analysis-region-invalid'>
    <div className='analysis-header nowrap'>
      <h3>
        <Icon extraClasses={['icon-lg']} id='fa-area-chart' />
        {'group' in selectionStore.data
          ? <span>{selectionStore.data.group.name}{' > '}</span>
          : null}
        <span>{selectionStore.item.name}</span>
      </h3>
    </div>
    <div className='analysis-contents'>
      <p className='analysis-invalid'>
        <Trans i18nKey='GLOBAL.ANALYSIS_INVALID'>
          This region could not be analyzed because, (1) the area is too small or (2) the polygon is too complex. If you believe you are receiving this message in error, please report it here: <a href={constants.SERVICE_DESK_URL} target='_blank' rel='noreferrer'>Report error</a>
        </Trans>
      </p>
    </div>
  </section>
)

export default withTranslation()(inject('selectionStore')(observer(RegionAnalysisInvalid)))
